<script>
  export let title = undefined;
  export let style = undefined;
  export let dimension = 60;

  let name = "rainfall";

  $: attributes = {
    width: dimension,
    height: dimension,
    role: title ? "img" : "presentation",
    ...(!title && { "aria-hidden": true }),
    ...(title && { "aria-labelledby": `icon-title-${name}` }),
    ...(style && { style }),
  };
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  preserveAspectRatio="xMidYMid meet"
  viewBox="0 0 62 62"
  {...attributes}
>
  {#if title}
    <title id="{`icon-title-${name}`}">{title}</title>
  {/if}
  <defs>
    <radialGradient id="gradient-rainfall">
      <stop offset="0" style="stop-color:#C8C8C8;stop-opacity:0.3"></stop>
      <stop offset="0.5" style="stop-color:#C8C8C8;stop-opacity:0.5"></stop>
      <stop offset="1" style="stop-color:#C8C8C8;stop-opacity:0.3"></stop>
    </radialGradient>
  </defs>
  <circle style="fill:url(#gradient-rainfall)" r="30" cy="31" cx="31"></circle>
  <g transform="matrix(2.0729435,0,0,2.0729435,-3.1286188,-1.1316607)">
    <path
      style="fill:#25a9e1"
      d="M 20.564,27.641 C 23.752,27.63 26.377,24.966 26.353,21.78 26.318,17.328 22.22,12.601 20.832,7.856 20.79,7.712 20.667,7.641 20.546,7.641 c -0.121,0 -0.244,0.071 -0.286,0.215 -1.388,4.745 -5.486,9.472 -5.521,13.924 -0.023,3.188 2.603,5.853 5.789,5.861"
    ></path>
    <path
      style="fill:#ffffff"
      d="M 20.561,24.838 C 23.114,24.83 25.211,22.7 25.194,20.15 25.168,16.587 21.886,12.807 20.778,9.01 20.745,8.895 20.645,8.837 20.549,8.837 c -0.099,0 -0.194,0.058 -0.229,0.173 -1.108,3.796 -4.389,7.576 -4.417,11.14 -0.019,2.552 2.081,4.682 4.632,4.688"
    ></path>
    <path
      style="fill:#25a9e1"
      d="m 22.096,23.559 c -0.14,0 -0.273,-0.076 -0.344,-0.209 -0.1,-0.188 -0.025,-0.424 0.164,-0.521 0.768,-0.398 1.32,-1.11 1.52,-1.947 0.051,-0.209 0.258,-0.338 0.469,-0.288 0.207,0.05 0.334,0.259 0.285,0.466 -0.25,1.06 -0.947,1.952 -1.914,2.457 -0.059,0.025 -0.122,0.042 -0.18,0.042 z"
    ></path>
    <path
      style="fill:#25a9e1"
      d="m 8.43,22.854 c 2.073,-0.006 3.779,-1.735 3.764,-3.81 C 12.172,16.148 9.507,13.078 8.606,9.993 8.578,9.899 8.499,9.854 8.42,9.854 c -0.079,0 -0.159,0.045 -0.186,0.14 -0.902,3.085 -3.566,6.155 -3.589,9.051 -0.015,2.072 1.691,3.805 3.764,3.811"
    ></path>
    <path
      style="fill:#ffffff"
      d="m 8.428,21.032 c 1.658,-0.003 3.023,-1.39 3.011,-3.048 C 11.421,15.67 9.29,13.213 8.567,10.745 8.546,10.669 8.482,10.633 8.419,10.633 c -0.063,0 -0.127,0.037 -0.148,0.112 -0.722,2.467 -2.854,4.925 -2.872,7.239 -0.011,1.658 1.354,3.045 3.012,3.048"
    ></path>
    <path
      style="fill:#25a9e1"
      d="m 9.426,20.2 c -0.091,0 -0.179,-0.05 -0.224,-0.136 -0.064,-0.121 -0.017,-0.272 0.107,-0.34 0.499,-0.26 0.859,-0.722 0.987,-1.266 0.032,-0.137 0.167,-0.221 0.304,-0.188 0.134,0.03 0.218,0.166 0.186,0.301 -0.163,0.688 -0.616,1.271 -1.244,1.599 -0.037,0.021 -0.076,0.03 -0.116,0.03 z"
    ></path>
    <path
      style="fill:#25a9e1"
      d="M 14.749,12.36 C 16.184,12.357 17.365,11.157 17.355,9.723 17.338,7.719 15.494,5.593 14.87,3.457 14.85,3.393 14.796,3.36 14.741,3.36 c -0.054,0 -0.111,0.032 -0.129,0.098 -0.625,2.135 -2.469,4.262 -2.485,6.266 -0.01,1.436 1.171,2.634 2.605,2.637"
    ></path>
    <path
      style="fill:#ffffff"
      d="m 14.745,11.101 c 1.148,-0.002 2.096,-0.962 2.086,-2.11 C 16.818,7.387 15.342,5.687 14.842,3.978 14.828,3.926 14.784,3.9 14.74,3.9 c -0.044,0 -0.088,0.026 -0.104,0.078 -0.5,1.708 -1.975,3.409 -1.988,5.013 -0.007,1.148 0.937,2.108 2.085,2.11"
    ></path>
    <path
      style="fill:#25a9e1"
      d="m 15.438,10.523 c -0.063,0 -0.123,-0.033 -0.155,-0.093 -0.044,-0.084 -0.011,-0.19 0.074,-0.236 0.346,-0.179 0.596,-0.498 0.685,-0.875 0.021,-0.094 0.115,-0.152 0.211,-0.13 0.093,0.023 0.15,0.117 0.128,0.209 -0.113,0.478 -0.428,0.879 -0.863,1.106 -0.027,0.015 -0.054,0.019 -0.08,0.019 z"
    ></path>
  </g>
</svg>
